export const checkServiceType = (serviceName?: 'reference' | 'compliance'): boolean =>
  (serviceName ?? 'compliance') === import.meta.env.VITE_SERVICE_NAME;
